<script setup lang="ts">
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { ContextAccess } from '@shared/Root/Context.access';
    import BsAlert from '@shared/components/BsAlert.vue';
    import { AlertTypes } from '@shared/components/BsAlerts';
    import { inject, computed } from 'vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const contextAccess: ContextAccess = injectorAccess.injector.get(ContextAccess);

    const show = computed(() => contextAccess.state.currentUser != null && !contextAccess.state.currentUser.EmailIsValidated);

    const emailBody = computed(() =>
        contextAccess.state.currentUser ? $Resources.AccountEmailValidatedBody.replace('{{Email}}', contextAccess.state.currentUser.Email) : ''
    );

    const reload = async () => {
        const result = await contextAccess.reloadUserAndCheckUserEmailValidation();
        if (result?.EmailIsValidated) {
            contextAccess.state.currentUser!.EmailIsValidated = result.EmailIsValidated;
        }
    };
</script>

<template>
    <BsAlert :show="show" :type="AlertTypes.Info" :title="$Resources.AccountEmailValidatedheading" :content="emailBody" :dismissible="false" effect="pulse">
        <template #content>
            <div class="d-flex gap-sm flex-wrap m-xs-t">
                <button type="button" class="btn btn-sm btn-info" @click="reload">
                    {{ $Resources.AccountEmailValidatedContinueButton }}
                </button>
                <button type="button" class="btn btn-sm btn-subtle" @click="contextAccess.sendValidation">
                    {{ $Resources.AccountEmailValidatedButton }}
                </button>
            </div>
        </template>
    </BsAlert>
</template>
